import { render } from "./CreateDocumentButton.vue?vue&type=template&id=74c3816c"
import script from "./CreateDocumentButton.vue?vue&type=script&lang=js"
export * from "./CreateDocumentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__